import { Typography, Button } from '@mui/material';
import Grid from 'components/core/Grid';
import { useListPageModalNavigation } from '../modal/hooks/useListPageModalNavigation';

import { ContentSection, StyledAppCard } from './styles';

export const GetStartedCard = ({ openModal }: { openModal: () => void }) => {
  const { pushUnassistedUrl } = useListPageModalNavigation();
  const onClick = () => {
    pushUnassistedUrl();
    openModal();
  };
  return (
    <ContentSection>
      <Grid container spacing={4}>
        <Grid item xs={12}>
          <StyledAppCard>
            <Typography variant="h3" mb={2}>
              Get Started Today
            </Typography>
            <Grid container spacing={4}>
              <Grid item xs={12} sm={8}>
                <Typography>
                  Begin by verifying some details about you and your property. Get instant access to the onboarding
                  wizard that will walk you through the setup process with absolutely no risk or upfront cost.
                </Typography>
              </Grid>
              <Grid item xs={12} sm={4}>
                <Button variant="contained" color="secondary" fullWidth size="large" onClick={onClick}>
                  Let&apos;s Get Started
                </Button>
              </Grid>
            </Grid>
          </StyledAppCard>
        </Grid>
      </Grid>
    </ContentSection>
  );
};
